// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteTagRequestModel from '../../model/delete-tag-request-model';
import DeleteTagRequestDTO from '../dto/delete-tag-request-dto';
import dtoSchema from '../schemas/delete-tag-request-schema';

export default abstract class DeleteTagRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteTagRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteTagRequestDTO>): DeleteTagRequestModel;
  static toModel(dto: DeepPartial<DeleteTagRequestDTO> | undefined | null): DeleteTagRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteTagRequestDTO> | undefined | null): DeleteTagRequestModel | undefined {
    return dto ? new DeleteTagRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteTagRequestModel> | DeleteTagRequestModel): DeleteTagRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteTagRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteTagRequestModel, can not map to DeleteTagRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
